import { keyframes } from "@mui/material";

export const runLand = keyframes`
  from { opacity: 0.3; transform: translateY(3px) scale(0.985); }
  60% { opacity: 1; transform: translateY(0) scale(1.006); }
  to { opacity: 1; transform: none; }
`;
